var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDiscoverActive = function SvgDiscoverActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#discover-active_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#discover-active_svg__b)",
    fillRule: "evenodd",
    d: "M2 11.75C2 6.365 6.365 2 11.75 2s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2 17.135 2 11.75Zm4.25 5.5 3.25-6.99c.16-.33.42-.6.76-.76l6.99-3.25L14 13.24c-.16.33-.42.6-.76.76l-6.99 3.25Zm4.75-5.5c0 .41.34.75.75.75s.75-.34.75-.75-.34-.75-.75-.75-.75.34-.75.75Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "discover-active_svg__b",
    x1: 2,
    x2: 4.79,
    y1: 2,
    y2: 23.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E61ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9662DB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "discover-active_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 2h19.5v19.5H2z"
  })))));
};
export default SvgDiscoverActive;